/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics.
 * All Rights Reserved.
 */

export default function PositioningSummaryCard({

    latestData = []

}) {

    if (!latestData.length) {

        return (

            <div
                className="
                    bg-slate-950
                    border
                    border-slate-800
                    rounded-3xl
                    p-6
                    text-slate-400
                "
            >
                No positioning summary available.
            </div>

        );

    }

    const formatNumber = value => {

        if (!value) return "0";

        if (Math.abs(value) >= 10000000) {

            return (
                value / 10000000
            ).toFixed(2) + " Cr";

        }

        if (Math.abs(value) >= 100000) {

            return (
                value / 100000
            ).toFixed(2) + " L";

        }

        return value.toLocaleString();

    };

    const summary = latestData.map(row => {

        const netOI =
            row.net_oi ??
            (
                row.total_long_oi -
                row.total_short_oi
            );

        return {

            client:
                row.client,

            netOI,

            bias:
                netOI > 0
                    ? "Bullish"
                    : netOI < 0
                    ? "Bearish"
                    : "Neutral"

        };

    });

    const mostBullish =
        [...summary]

            .sort(
                (a, b) =>
                    b.netOI -
                    a.netOI
            )[0];

    const mostBearish =
        [...summary]

            .sort(
                (a, b) =>
                    a.netOI -
                    b.netOI
            )[0];

    const totalNet =
        summary.reduce(

            (acc, row) =>
                acc + row.netOI,

            0

        );

    const marketBias =
        totalNet > 0
            ? "Bullish"
            : totalNet < 0
            ? "Bearish"
            : "Neutral";

    return (

        <div
            className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-6
            "
        >

            <div
                className="
                    mb-6
                "
            >

                <h2
                    className="
                        text-xl
                        font-semibold
                        text-white
                    "
                >
                    Institutional Positioning Summary
                </h2>

                <p
                    className="
                        text-sm
                        text-slate-400
                    "
                >
                    Snapshot of current market participant positioning
                </p>

            </div>

            {/* TOP CARDS */}

            <div
                className="
                    grid
                    grid-cols-1
                    md:grid-cols-3
                    gap-4
                    mb-6
                "
            >

                <div
                    className="
                        bg-slate-900
                        rounded-2xl
                        p-4
                    "
                >

                    <div
                        className="
                            text-slate-400
                            text-sm
                            mb-2
                        "
                    >
                        Market Bias
                    </div>

                    <div
                        className={`
                            text-2xl
                            font-bold

                            ${
                                marketBias ===
                                "Bullish"

                                    ? "text-emerald-400"

                                    : marketBias ===
                                      "Bearish"

                                    ? "text-red-400"

                                    : "text-slate-300"
                            }
                        `}
                    >
                        {marketBias}
                    </div>

                    <div
                        className="
                            text-xs
                            text-slate-500
                            mt-2
                        "
                    >
                        Aggregate Net OI
                    </div>

                </div>

                <div
                    className="
                        bg-slate-900
                        rounded-2xl
                        p-4
                    "
                >

                    <div
                        className="
                            text-slate-400
                            text-sm
                            mb-2
                        "
                    >
                        Most Bullish
                    </div>

                    <div
                        className="
                            text-lg
                            font-bold
                            text-emerald-400
                        "
                    >
                        {mostBullish?.client}
                    </div>

                    <div
                        className="
                            text-sm
                            text-slate-300
                            mt-1
                        "
                    >
                        {formatNumber(
                            mostBullish?.netOI
                        )}
                    </div>

                </div>

                <div
                    className="
                        bg-slate-900
                        rounded-2xl
                        p-4
                    "
                >

                    <div
                        className="
                            text-slate-400
                            text-sm
                            mb-2
                        "
                    >
                        Most Bearish
                    </div>

                    <div
                        className="
                            text-lg
                            font-bold
                            text-red-400
                        "
                    >
                        {mostBearish?.client}
                    </div>

                    <div
                        className="
                            text-sm
                            text-slate-300
                            mt-1
                        "
                    >
                        {formatNumber(
                            mostBearish?.netOI
                        )}
                    </div>

                </div>

            </div>

            {/* CLIENT TABLE */}

            <div
                className="
                    overflow-x-auto
                "
            >

                <table
                    className="
                        w-full
                        text-sm
                    "
                >

                    <thead>

                        <tr
                            className="
                                border-b
                                border-slate-800
                                text-slate-400
                            "
                        >

                            <th
                                className="
                                    text-left
                                    py-3
                                "
                            >
                                Client
                            </th>

                            <th
                                className="
                                    text-right
                                    py-3
                                "
                            >
                                Net Position
                            </th>

                            <th
                                className="
                                    text-center
                                    py-3
                                "
                            >
                                Bias
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {summary.map(
                            row => (

                                <tr
                                    key={
                                        row.client
                                    }
                                    className="
                                        border-b
                                        border-slate-900
                                    "
                                >

                                    <td
                                        className="
                                            py-3
                                            text-white
                                        "
                                    >
                                        {
                                            row.client
                                        }
                                    </td>

                                    <td
                                        className={`
                                            py-3
                                            text-right
                                            font-medium

                                            ${
                                                row.netOI >
                                                0
                                                    ? "text-emerald-400"
                                                    : row.netOI <
                                                      0
                                                    ? "text-red-400"
                                                    : "text-slate-300"
                                            }
                                        `}
                                    >
                                        {
                                            formatNumber(
                                                row.netOI
                                            )
                                        }
                                    </td>

                                    <td
                                        className="
                                            py-3
                                            text-center
                                        "
                                    >

                                        <span
                                            className={`
                                                px-3
                                                py-1
                                                rounded-full
                                                text-xs
                                                font-medium

                                                ${
                                                    row.bias ===
                                                    "Bullish"
                                                        ? "bg-emerald-900 text-emerald-300"
                                                        : row.bias ===
                                                          "Bearish"
                                                        ? "bg-red-900 text-red-300"
                                                        : "bg-slate-800 text-slate-300"
                                                }
                                            `}
                                        >
                                            {
                                                row.bias
                                            }
                                        </span>

                                    </td>

                                </tr>

                            )
                        )}

                    </tbody>

                </table>

            </div>

        </div>

    );

}